import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule } from '@angular/material';

import { ConfirmDialogComponent } from './confirm-dialog.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        ConfirmDialogComponent
    ],
    imports: [
		TranslateModule,
        MatDialogModule,
        MatButtonModule
	],
    entryComponents: [
        ConfirmDialogComponent
	],
	exports: [
		ConfirmDialogComponent
	],
})
export class ConfirmDialogModule
{
}
